var _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "20c12caf-9e56-4505-a873-6b90d830c132",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 241.62 241.62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Download") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 120.81,
    cy: 120.81,
    r: 120.81,
    fill: "#bcd6fb"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M455.83,312.14H366.17a4,4,0,0,1-4-4v-24a4,4,0,0,1,8,0v20h81.66v-20a4,4,0,0,1,8,0v24A4,4,0,0,1,455.83,312.14Z",
    transform: "translate(-290.19 -144.19)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M446.51,249.57a4,4,0,0,0-5.61-.66l-26.28,20.75V207.25a4,4,0,0,0-8,0v62.26l-25.47-20.7a4,4,0,0,0-5,6.21l32,26,0,0,.13.08a3.36,3.36,0,0,0,.57.35l.24.11a3.86,3.86,0,0,0,.54.19l.23.06a4.26,4.26,0,0,0,.8.09h0a4.15,4.15,0,0,0,.78-.09l.21-.05a3.19,3.19,0,0,0,.59-.21l.13,0,.1,0,.21-.13c.12-.07.24-.14.35-.22l.1-.07,32.75-25.87A4,4,0,0,0,446.51,249.57Z",
    transform: "translate(-290.19 -144.19)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/Download.70bbfe98b9f3356b8e71d562aa1cad04.svg";
export { ForwardRef as ReactComponent };